export const SIZE = {
    SMALL: 0,
    MEDIUM: 1
};